import ApiClient from './ApiClient';

class BalanceClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}` : '');
  }

  async updateExchangeRate() {
    try {
      const { data } = await this.get(`/btc`);
      return data.price;
    } catch (error) {
      throw new Error(`Failed to update exchange rate: ${error.message}`);
    }
  }

  async getPriceGroups(query = {}) {
    try {
      const data = await this.get('/', query);
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch price groups: ${error.message}`);
    }
  }

  async createPriceGroup(priceGroupData) {
    try {
      const data = await this.post('/', priceGroupData);
      return data;
    } catch (error) {
      throw new Error(`Failed to create price group: ${error.message}`);
    }
  }

  async updatePriceGroup(priceGroupId, updatedFields) {
    try {
      const data = await this.put(`/${priceGroupId}`, updatedFields);
      return data;
    } catch (error) {
      throw new Error(`Failed to update price group: ${error.message}`);
    }
  }
}

export default BalanceClient;
